import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import withLoader from "../../../components/layouts/WithLoader";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DataTableBordereauDetails from "./DataTableBordereauDetails";
import SellingService from "../../../services/SellingService";
import UtilsFormule from "../../../utils/UtilsFormule";

const BordereauDetails = ({ startLoading, stopLoading }) => {
  const [bordereauDetailsInfo, setBordereauDetailsInfo] = useState([]);
  const [listCheques, setListCheques] = useState([]);
  const [dateOperation, setDateOperation] = useState("any");
  const [referenceOperation, setReferenceOperation] = useState("");
  const [rapproched,setRapproched]=useState(true);

  useEffect(() => {
    SellingService.getPayementsFromBorderau(
      getCurrentUserId(),
      localStorage.getItem("idBordereauDetails")
    )
      .then((response) => {
        console.log(response);
        if (response.data.borderau) {
          setBordereauDetailsInfo(response?.data?.borderau);
          setListCheques(response?.data?.borderau?.payements);
          if(response?.data?.borderau?.refOperation!==null){
            setRapproched(false)
          }
        }
      })
      .catch(() => {
        console.log("error");
      });
  }, []);

  // const onGetChequeByFiltersHandler = () => {
  //   startLoading();
  //   BanqueService.getListPayementsChequeByBankAccountBetweenDates(
  //     getCurrentUserId(),
  //     sessionStorage.getItem("idBankAccount"),
  //     methodePayement,
  //     dateBegin,
  //     dateEnd
  //   )
  //     .then((response) => {
  //       console.log(response);
  //       if (response.data.success) {
  //         setListTransaction(response.data.success);
  //       }
  //     })
  //     .catch(() => {
  //       console.log("error");
  //     })
  //     .finally(() => {
  //       stopLoading();
  //     });
  // };

  // const handleChangePayementMethode = (event) => {
  //   if (event.target.value === "VIREMENT") {
  //     setMethodePayement(3);
  //   } else if (event.target.value === "CHEQUE") {
  //     setMethodePayement(2);
  //   }
  // };

  const onChangeDateOperation = (event) => {
    setDateOperation(event.target.value.concat(":00"));
  };

  const onChangeReferenceOperation = (event) => {
    setReferenceOperation(event.target.value);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h4 class="card-title">
                    <b>Details Bordereau :</b>
                  </h4>
                  <br />
                  <br />
                  {bordereauDetailsInfo && (
                    <>
                      <p>
                        Date de creation :{" "}
                        <b>
                          {bordereauDetailsInfo?.creationDate &&
                            UtilsFormule.formatDate(
                              bordereauDetailsInfo?.creationDate
                            )}
                        </b>
                      </p>
                      <p>
                        Reference :{" "}
                        <b>
                          {bordereauDetailsInfo?.ref || ""}-
                          {bordereauDetailsInfo?.year || ""}
                        </b>
                      </p>
                    </>
                  )}
                </div>
              </div>

              {/* {listTransaction && <DataTableTransactions listTransaction={listTransaction} />} */}
            </div>
          </div>
        </div>
      </div>

      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputClientCompany">
                          Reference operation
                        </label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={referenceOperation}
                          onChange={onChangeReferenceOperation}
                          // id="datetime-local"
                          // label="Date Début"
                          type="text"
                          // defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date operation</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateOperation}
                          onChange={onChangeDateOperation}
                          id="datetime-local"
                          // label="Date Début"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetChequeByFiltersHandler}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              {listCheques?.length > 0 && (
                <DataTableBordereauDetails
                idBorderau={bordereauDetailsInfo?.id}
                rapproched={rapproched}
                  listCheques={listCheques}
                  dateOperation={dateOperation}
                  referenceOperation={referenceOperation}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(BordereauDetails);
